import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00c9a7]/50 disabled:opacity-50 disabled:cursor-not-allowed font-orbitron tracking-wide';
  const variants = {
    primary: 'bg-gradient-to-r from-[#1a4fd6] to-[#00c9a7] hover:to-[#00f5a0] text-white shadow-lg shadow-blue-900/20 hover:shadow-cyan-500/30',
    secondary: 'bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm border border-white/10',
    outline: 'bg-transparent border border-[#00c9a7] text-[#00c9a7] hover:bg-[#00c9a7]/10 hover:shadow-[0_0_15px_rgba(0,201,167,0.4)]',
    ghost: 'bg-transparent hover:bg-white/5 text-gray-300 hover:text-white'
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    md: 'h-11 px-6 text-sm',
    lg: 'h-14 px-8 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-274">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-275" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-276">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-277">{rightIcon}</span>}
    </button>;
}